import { render } from "./Modal.vue?vue&type=template&id=2d42ab2c"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
script.render = render

export default script